import React from 'react';
import styled from 'styled-components';
import CustomImg2 from '../common/image/CustomImg2';
import HpPopUpContainer from './HpPopUpContainer';
import {isMobileOnly} from 'react-device-detect'

const HpMainBannerBlock = styled.div`
  // margin: 0 auto;
  padding-top: 80px;
  width: 100%;
  text-align: center;
  //background: #fef7c8;
`;

const width= isMobileOnly?"400px":"1600px";
const height= isMobileOnly?"":"650px";
const marginBottom = isMobileOnly?"":"-5px";
const objectFit = isMobileOnly?"scale-down":"cover";
const HpMainBanner = () => {
  return (
    <HpMainBannerBlock >
      <CustomImg2 img_src="/assets/images/common/main-banner_202009.png"
        width={width} height={height} marginBottom={marginBottom} objectFit={objectFit} />
        <HpPopUpContainer />
    </HpMainBannerBlock>
  );
};

export default HpMainBanner;
